var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamelot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 819.7 200",
    style: {
      enableBackground: "new 0 0 819.7 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0 {\n            fill: #161616;\n        }\n\n        .st1 {\n            fill: #FFAF1D;\n        }\n\n        .st2 {\n            fill: #161616;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.1,148.7c-11.6,0-20.8-3.2-27.5-9.7c-6.8-6.5-10.2-15.7-10.2-27.7V88.8c0-12,3.4-21.3,10.2-27.7 c6.8-6.5,15.9-9.7,27.5-9.7c11.5,0,20.4,3.1,26.7,9.4c6.3,6.3,9.4,14.9,9.4,25.9v0.8h-17.4v-1.3c0-5.5-1.5-10.1-4.6-13.6 c-3.1-3.6-7.8-5.3-14.1-5.3c-6.2,0-11.1,1.9-14.7,5.7c-3.6,3.8-5.3,9-5.3,15.6v23c0,6.5,1.8,11.7,5.3,15.6 c3.6,3.9,8.5,5.8,14.7,5.8c6.3,0,11-1.8,14.1-5.4c3.1-3.6,4.6-8.1,4.6-13.6v-2.4h17.4v1.9c0,11-3.1,19.6-9.4,25.9 C291.5,145.5,282.6,148.7,271.1,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.2,146.8l24.6-93.6h30.7l24.6,93.6h-18.2l-5.1-20.6h-33.4l-5.1,20.6H314.2z M341.6,109.9h25.1l-11.4-45.6 h-2.4L341.6,109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.3,146.8V53.2h32.7l16.2,81.5h2.4l16.2-81.5h32.7v93.6h-17.1V66.2h-2.4l-16,80.6h-29.1l-16-80.6h-2.4v80.6 H405.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M523.2,146.8V53.2h60.1v16h-42.5v22.3h38.8v16h-38.8v23.1h43.3v16H523.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M597.3,146.8V53.2h17.6v77.5h42.8v16H597.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M702.9,148.7c-11.8,0-21.1-3.2-28.1-9.7c-7-6.5-10.4-15.7-10.4-27.7V88.8c0-12,3.5-21.3,10.4-27.7 c7-6.5,16.3-9.7,28.1-9.7s21.1,3.2,28.1,9.7c7,6.5,10.4,15.7,10.4,27.7v22.5c0,12-3.5,21.3-10.4,27.7 C724,145.4,714.6,148.7,702.9,148.7z M702.9,132.9c6.6,0,11.7-1.9,15.4-5.7c3.7-3.8,5.5-9,5.5-15.4V88.2c0-6.4-1.8-11.5-5.5-15.4 c-3.7-3.8-8.8-5.7-15.4-5.7c-6.5,0-11.6,1.9-15.3,5.7c-3.7,3.8-5.5,9-5.5,15.4v23.5c0,6.4,1.8,11.5,5.5,15.4 C691.2,131,696.4,132.9,702.9,132.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M774.8,146.8V69.3h-27.3v-16h72.2v16h-27.3v77.5H774.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.1,200v-82.2c19.6,2.1,32.9,11.1,32.9,11.1l12.5-14.1c-20.5-14.6-50.9-15.2-50.9-15.2l-5-55.2 c3.3-2.2,5.5-5.9,5.5-10.2c0-6.7-5.5-12.2-12.2-12.2s-12.2,5.5-12.2,12.2c0,4.3,2.2,8.1,5.5,10.2l-5,55.2c0,0-30.4,0.5-50.9,15.2 l12.5,14.1c0,0,13.3-9,32.9-11.1V200C6.1,143.2-0.2,60.7,0,33.3c0-5.7,3.4-10.9,8.6-13.2C23.9,13.3,58.8,0,99.8,0 c41,0,75.9,13.3,91.2,20.1c5.2,2.3,8.6,7.5,8.6,13.2C199.8,60.7,193.5,143.2,117.1,200z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamelot);
export default __webpack_public_path__ + "static/media/camelot.0cf21339bc61afa045daac495fa114e8.svg";
export { ForwardRef as ReactComponent };